import { render, staticRenderFns } from "./sandboxed_mermaid.vue.js?vue&type=template&id=d8877a58!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sandboxed_mermaid.vue?vue&type=template&id=d8877a58"
import script from "./sandboxed_mermaid.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sandboxed_mermaid.vue?vue&type=script&lang=js"
export * from "./sandboxed_mermaid.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sandboxed_mermaid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports